@if (isOpened()) {
    <div
        class="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
        [companyidDisabledScroll]="isOpened()!"
    >
        <div
            class="flex flex-col items-center bg-white p-30px rounded-8px box-shadow-4 gap-y-25px w-[570px] mob:w-11/12"
        >
            @if (type() === 'success') {
                <img [ngSrc]="'envelope-success' | asset: 'shared/modal'" alt="envelope" width="58" height="58" />
                <div class="flex flex-col gap-y-25px text-dark text-center items-center">
                    <span class="text-h6-semi-bold" i18n=":@@modal-title-success">Success</span>
                    <span class="text-small-medium" i18n=":@@modal-msg-success">
                        Thank you for your request! <br />
                        Your contact information has been sent.</span
                    >
                    <button class="button-primary" i18n=":@@button-confirm" (click)="closeModal()">Confirm</button>
                </div>
            }

            @if (type() === 'error') {
                <img [ngSrc]="'envelope' | asset: 'shared/modal'" alt="envelope-error" width="58" height="58" />
                <div class="flex flex-col gap-y-25px text-dark text-center items-center">
                    <span class="text-h6-semi-bold" i18n=":@@modal-title-error">Error</span>
                    <span class="text-small-medium" i18n=":@@modal-msg-error">
                        Oops! Something went wrong. Please try again later.
                    </span>
                    <button class="button-primary" i18n=":@@button-try-again" (click)="closeModal()">Try again</button>
                </div>
            }

            @if (type() === 'loading') {
                <img [ngSrc]="'envelope' | asset: 'shared/modal'" alt="envelope" width="58" height="58" />
                <div class="flex items-center gap-2.5">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        class="animate-spin"
                    >
                        <path
                            d="M30.5 16C30.5 13.7118 29.9584 11.456 28.9196 9.41714C27.8808 7.3783 26.3741 5.61426 24.5229 4.26926"
                            stroke="#3E57F0"
                            stroke-width="3"
                            stroke-linecap="round"
                        />
                    </svg>
                    <span class="text-dark-6 text-medium-medium" i18n=":@@modal-msg-sending">Sending...</span>
                </div>
            }
        </div>
    </div>
}
